import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { EMPTY, catchError } from 'rxjs';

import { MatrixCardComponent } from '../../../../shared/components/matrix-card/matrix-card.component';
import { GenericChartComponent } from '../../../../shared/echarts/components/generic-chart/generic-chart.component';
import { LoadingComponent } from '../../../../shared/components/loading/loading.component';
import { MatrixTrackerCardData } from '../../models/matrix-tracker-chart';
import { DASHBOARD_DATA } from '../../services/dashboard-data.token';
import { OrganizationService } from '../../../../core/services/organization.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-matrix-tracker-card',
  standalone: true,
  imports: [CommonModule, GenericChartComponent, MatrixCardComponent, LoadingComponent, TranslateModule],
  templateUrl: './matrix-tracker-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatrixTrackerCardComponent {
  @Input() highlighted = false;

  private readonly dashboardData = inject(DASHBOARD_DATA);
  private readonly organizationService = inject(OrganizationService);

  readonly error = signal(false);

  // toSignal initializes synchronously when the service returns a cached (of()) observable,
  // so the spinner never flashes on repeat visits.
  readonly data = toSignal(
    this.dashboardData
      .getMatrixTrackerCardData({
        organizationId: this.organizationService.organizationIdParam(),
        daysBack: '180',
      })
      .pipe(
        catchError(() => {
          this.error.set(true);
          return EMPTY;
        })
      ),
    { initialValue: null }
  );

  readonly loading = computed(() => this.data() === null && !this.error());

  reviewedPct(data: MatrixTrackerCardData): number {
    if (data.totalVariances <= 0) return 0;
    return Math.round((data.reviewed / data.totalVariances) * 100);
  }
}


